import React, { PureComponent } from 'react';
import ServiceUnavailableScreen from './ServiceUnavailableScreen';

export default class ServiceUnavailableScreenNoButton extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <ServiceUnavailableScreen
        closeModal={() => this.props.closeModal()} // reason it is not this.props.closeModal is because the default param doesn't get passed in correctly otherwise
        isServiceAvailable={this.props.isServiceAvailable}
        showButton={false}
      />
    );
  }
}

ServiceUnavailableScreenNoButton.navigationOptions = {
  header: null,
};

// Note: This is needed because publishing to expo runs minify, which changes the class names. In particular, classes
//       can end up with the same name which breaks the screen transition logic.
ServiceUnavailableScreenNoButton.viewName = 'ServiceUnavailableScreenNoButton';
